import { useEffect } from 'react';
import { presenceHeartbeat } from '../api/apiClient';

// No UI. On app open it pings the server, which sets the user's status
// automatically: "In the office" on the firm wifi, otherwise "Remote".
// Anyone who hasn't opened the site today stays "Away" by default.
const DailyCheckIn = ({ currentUser }) => {
  useEffect(() => {
    if (currentUser?.id) presenceHeartbeat().catch(() => {});
  }, [currentUser]);
  return null;
};

export default DailyCheckIn;
